import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { UpdateFolderInput, UpdateFolderMutation } from '@/gql/graphql';

const UPDATE_FOLDER_MUTATION = graphql(`
  mutation UpdateFolder($input: UpdateFolderInput!) {
    updateFolder(input: $input) {
      id
      name
      parentId
      isRoot
    }
  }
`);

const useUpdateFolder = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    UpdateFolderMutation,
    unknown,
    UpdateFolderInput
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UPDATE_FOLDER_MUTATION, { input });
    },
    onSuccess: () => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.folders(args.projectId),
        });
      }
    },
    ...args?.options,
  });
};

export default useUpdateFolder;
